import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-tailwind/react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import "./Listing.css";

const Listing = ({ list, title, eyebrow, description, Component }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <div ref={ref} className={`listing-container ${isVisible ? 'listing-visible' : ''}`}>
      <div className="listing-header">
        {eyebrow ? <p className="listing-eyebrow">{eyebrow}</p> : null}
        <Typography variant="h3" className="listing-title">
          {title}
        </Typography>
        {description ? (
          <Typography className="listing-description">
            {description}
          </Typography>
        ) : null}
      </div>
      <div className="listing-items">
        {[...list].reverse().map((item, index) => (
          <Component key={index} {...item} animationDelay={index} />
        ))}
      </div>
    </div>
  );
};

Listing.propTypes = {
  list: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  eyebrow: PropTypes.string,
  description: PropTypes.string,
  Component: PropTypes.elementType.isRequired,
};

export default Listing;
